// extracted by mini-css-extract-plugin
export default {"container":"LandingFooter_container__rsCag","footer":"LandingFooter_footer__6u7m2","info":"LandingFooter_info__KDEIS"};